import { render } from "./AccountForgotPassword.vue?vue&type=template&id=b27b11d6"
import script from "./AccountForgotPassword.vue?vue&type=script&lang=js"
export * from "./AccountForgotPassword.vue?vue&type=script&lang=js"
script.render = render

export default script